







import { Component, Vue, Prop } from 'vue-property-decorator';

import segmentIo from '@/utils/segment.io';

import LocationManager from '@/components/LocationManager/LocationManager.vue';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';

import { ILocation } from '@/models/location';

@Component({
  components: {
    SideModalHeader,
    FlexButton,
    LocationManager
  }
})
export default class LocationDetails extends Vue {
  @Prop({ required: true }) data!: {
    location?: ILocation;
    type: 'edit' | 'create';
  };

  mounted() {
    segmentIo.modal(`${this.type === 'create' ? 'New' : 'Edit'} Location`);
  }

  get description() {
    if (this.type === 'create')
      return 'Enter below the info for the this new location.';

    return 'Edit below the info for the this location.';
  }

  get location() {
    return this.data.location;
  }

  get type() {
    return this.data.type;
  }

  get title() {
    if (this.type === 'create') return 'New Location';

    return this.businessName;
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get businessName() {
    return this.business.name;
  }
}
